$(function() {
    'use strict';

    var banners = $('.section-more-info-navigation .banner');
    var h = 0;

    banners.each(function(i, child) {
        var $child = $(child);
        if ($child.height() > h) {
            h = $child.height();
        }
    });
    banners.height(h);
});
